import CustomQuill from './CustomQuill';
import {BootstrapQuillToolbarDropDown, QuillToolbarDropDown} from './DynamicQuillTools';
import NUQuillAccessibilityPatch from "./a11y-fixes";
import quill from "quill/quill";

/**
 * Initialize a Quill editor with the Application Data Model variable insert toolbar & our a11y fixes.
 *
 * @returns {CustomQuill} The underlying Quill instance used to instantiate NUQuill
 * @param {string} elementSelector Selector for the <div> to attach Quill to.
 * @param {string} hiddenInputId The ID of an <input type="hidden"> field to sync values to.
 * @param {boolean} [params.isHtml = false] Whether to include the rich formatting features.  false
 * @param {?string} [params.value = null] The initial value
 * @param {?array} [params.admVariables = null] The DataModelVariableResource for the workflow(s)
 * @param {?object} [params.contentVariables = null] Content data (i.e., type and ID) providing Quill's context
 * @param {boolean} [params.useBootstrap = true] Whether to use the fancy bootstrap-y version of the dropdown
 * @param {boolean} [params.useFancyADMLabels = false] Whether to display the nicely formatted ADM Labels or show the {{ some.adm.path }} value. Currently only the notification have the label-replacement implemented.
 * @param {boolean} [params.useReadMore = false] Whether to allow a special divider currently used in cycle descriptions to hidden text below the divider.
 * @param {boolean} [params.readonly = false] Whether to disable the Quill editor so it is readonly
 * @constructor
 */
const NUQuill = (elementSelector, hiddenInputId, params) => {
    params = _.defaults(params, {
        isHtml: true,
        value: null,
        admVariables: null,
        contentVariables: null,
        useBootstrap: true,
        useFancyADMLabels: false,
        useReadMore: false,
        readonly: false,
    });

    let dropdown;
    if (params.useBootstrap) {
        const qlDropdownId = `ql-adm-${elementSelector.replace('#', '')}`;
        dropdown = new BootstrapQuillToolbarDropDown({
            label: "Insert Variable",
            rememberSelection: false,
            id: qlDropdownId,
        });

        $(function() {
            // initialize fancy BootStrap Dropdown-ification of the quill ADM variable dropdowns
            $(`#${qlDropdownId}`).selectpicker({
                noneSelectedText: 'Insert Variable',
                style: '',
                styleBase: 'form-control',
                selectedTextFormat: 'static',
                liveSearch: true,
            });

            $(`#${qlDropdownId}`).on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                e.target.selectedOptions[0].onclick(); // execute the event listener callback defined in Dynamic Quill Tools for the selected item
                // override the default dropdown thing of having an option selected now
                $('.ql-adm-dropdown').val('').selectpicker('deselectAll');
                $('.ql-adm-dropdown').selectpicker('refresh'); // for the above line to take effect
            });

            $(`#${qlDropdownId}`).on('shown.bs.select', function() {
                // tried setting it on the optgroups in the underlying dropdown, it puts the class on the options too when initializing the bootstrap options
                $(this).siblings('.dropdown-menu').find('.dropdown-header').addClass('sticky-top-1');
            });
        });
    } else {
        dropdown = new QuillToolbarDropDown({
            label: "Insert Variable",
            rememberSelection: false,
        });
    }

    dropdown.onSelect = function(label, value, group, quill, deferredTag, unescaped, modifier) {
        // Deferred tags use {[{, which is special in our mustache implementation.
        const openTag = deferredTag
            ? '\{[\{ '
            : unescaped
                ? '\{\{\{ '
                : '\{\{ ';

        const closeTag = unescaped ? ' }}}' : ' }}'

        if (modifier) {
            value = value + '|' + modifier;
        }

        value = openTag + value + closeTag;

        const {
            index,
            length
        } = quill.selection.savedRange;

        if (params.useFancyADMLabels) {
            const admVariable = {
                value,
                label,
                group,
            };

            quill.deleteText(index, length);
            quill.insertEmbed(index, 'adm-blot', admVariable);
            quill.setSelection(index + 1); // uneditable ADM blot has length 1 for this purpose
        } else {
            quill.deleteText(index, length);
            quill.insertText(index, value);
            quill.setSelection(index + value.length);
        }
    };

    // if the contentVariables argument is null or missing a content type/ID, turn off the image format
    let enableImages = false;
    if (params.isHtml === true && params.contentVariables && params.contentVariables['type'] && params.contentVariables['id']) {
        enableImages = true;
    }

    var quillEditor = new CustomQuill(elementSelector, {
        theme: 'snow',
        modules: getModules(enableImages, params.useReadMore),
    });

    if (params.readonly) {
        quillEditor.enable(false);
    }

    function getModules(enableImages, enableReadMore) {
        let modules = {};

        if (params.isHtml === false || params.readonly) {
            modules['toolbar'] = [];
            return modules
        }

        modules['toolbar'] = {
            container: [{'header': [1, 2, 3, false]}, 'bold', 'italic', 'underline', 'link', {'list': 'ordered'}, {'list': 'bullet'}, 'clean'],
            handlers: {image: imageHandler, readMore: readMoreHandler}
        }

        if (enableImages) {
            modules['toolbar']['container'].push('image');
        }

        if (enableReadMore) {
            modules['toolbar']['container'].push('readMore');
        }

        return modules
    }

    function readMoreHandler() {
        let range = this.quill.getSelection(true);
        this.quill.insertText(range.index, '\n', quill.sources.USER);
        this.quill.insertEmbed(range.index + 1, 'readMore', true, quill.sources.USER);
        this.quill.setSelection(range.index + 2, quill.sources.SILENT);
    }

    function imageHandler() {
        // select local image
        let fileInput = this.container.querySelector('input.ql-image[type=file]');

        if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', () => {
                const files = fileInput.files;
                const range = this.quill.getSelection(true);

                if (!files || !files.length) {
                    console.log('No files selected');
                    return;
                }

                this.quill.enable(false);

                // get presigned S3 url
                return fetch('/dynamic-forms/storage/s3/upload-link')
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                        let signed = data.signed;
                        let aclType = data.headers['x-amz-acl'][0];
                        let encryptionType = data.headers['x-amz-server-side-encryption'][0];
                        let encryptionKey = data.headers['x-amz-server-side-encryption-aws-kms-key-id'][0];
                        let fileKey = data['file_key'];
                        uploadImageToS3(signed, files[0], aclType, encryptionType, encryptionKey, fileKey);
                        this.quill.enable(true);
                        fileInput.value = '';
                    })
            })
            this.container.appendChild(fileInput);
        }
        fileInput.click();
    }

    function uploadImageToS3(url, file, aclType, encryptionType, encryptionKey, fileKey) {
        return fetch(url, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/octet-stream',
                'x-amz-acl': aclType,
                'x-amz-server-side-encryption': encryptionType,
                'x-amz-server-side-encryption-aws-kms-key-id': encryptionKey,
            },
            body: file
        })
            .then(response => {
                console.log(response);
                getImageFromS3(fileKey);
            });
    }

    function getImageFromS3(fileKey) {
        return fetch(`/dynamic-forms/storage/s3/display-object/${fileKey}`, {
            headers: {
                'quill-content-type': params.contentVariables['type'],
                'quill-content-id': params.contentVariables['id']
            }
        })
        .then(response => {
            console.log(response);
            let range = quillEditor.getSelection();
            quillEditor.insertEmbed(range.index, 'image', response.url)
        });
    }


    quillEditor.on('text-change', function(delta, source) {
        if (params.useFancyADMLabels) {
            // now that we have fancy ADM variables which get swapped out on the server-side for underlying values, all fields have to support html in the quil editor, even if not an email field ultimately supporting HTML
            let currentValue = quillEditor.container.firstChild.innerHTML

            // if HTML matches empty quill document, rm hidden input
            // necessary in case they entered text then deleted it
            // won't be properly evaluated for validation rules as if they never entered anything
            if (currentValue === '<p><br></p>') {
                document.getElementById(hiddenInputId).value = '';
            } else {
                document.getElementById(hiddenInputId).value = currentValue;
            }
        } else {
            const currentValue = params.isHtml
                ? quillEditor.container.firstChild.innerHTML
                : quillEditor.getText();
            document.getElementById(hiddenInputId).value = currentValue;
        }
    });

    if (params.useFancyADMLabels) {
        quillEditor.setContents(quillEditor.clipboard.convert(params.value));
    } else {
        if (params.isHtml) {
            quillEditor.setContents(quillEditor.clipboard.convert(params.value));
        } else {
            quillEditor.setText(params.value);
        }
    }

    if (params.admVariables !== null) {
        dropdown.attach(quillEditor);
        dropdown.setItems(params.admVariables);
    }

    NUQuillAccessibilityPatch( elementSelector + ' .ql-toolbar');

    return quillEditor;
};

export default NUQuill;
